import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import type { RelatedEntity } from '../utils/entity-utils';

export type OpenEntityDetailRequest = RelatedEntity & {
  projectId?: string;
};

interface OpenEntityDetailValue {
  openEntityDetail: (entity: RelatedEntity) => void;
  closeEntityDetail: () => void;
  request: OpenEntityDetailRequest | null;
}

const OpenEntityDetailContext = createContext<OpenEntityDetailValue | null>(null);

export function opensEntityDetailInPlace(type: string): boolean {
  return type === 'character' || type === 'location';
}

export const OpenEntityDetailProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const params = useParams<{ projectId?: string }>();
  const routeProjectId = params.projectId && params.projectId !== 'new' ? params.projectId : undefined;
  const [request, setRequest] = useState<OpenEntityDetailRequest | null>(null);

  const openEntityDetail = useCallback(
    (entity: RelatedEntity) => {
      setRequest({
        ...entity,
        projectId: routeProjectId,
      });
    },
    [routeProjectId],
  );

  const closeEntityDetail = useCallback(() => {
    setRequest(null);
  }, []);

  const value = useMemo(
    () => ({
      openEntityDetail,
      closeEntityDetail,
      request,
    }),
    [openEntityDetail, closeEntityDetail, request],
  );

  return (
    <OpenEntityDetailContext.Provider value={value}>
      {children}
    </OpenEntityDetailContext.Provider>
  );
};

export function useOpenEntityDetailOptional(): OpenEntityDetailValue | null {
  return useContext(OpenEntityDetailContext);
}
